import { Navigate, useRoutes } from "react-router-dom";
import CertificatePage from "../modules/ekyc/components/CertificatePage";
import VerificationSuccess from "../modules/VerificationSuccess";
import LivenessScan from "../components/liveness/LivenessScan";
import EKYCManager from "../modules/ekyc_manager/EKYCManager";

const ThemeRoutes = () => {
  return useRoutes([
    {
      path: "/",
      element: <Navigate to="/admin" replace />,
    },
    {
      path: "/verification-certificate/:clientID/:refID",
      element: <CertificatePage />,
    },
    {
      path: "/ekyc/verification-success",
      element: <VerificationSuccess />,
    },
    {
      path: "/liveness/:sessionId",
      element: <LivenessScan />,
    },
    {
      path: "/ekyc",
      element: <EKYCManager />,
    },
  ]);
};

export default ThemeRoutes;
